import React from 'react';

import Accordion from 'relements/build/esm/ui/accordion';

import { SortableElement } from 'react-sortable-hoc';
import {
  openComponentModal,
  closeComponentModal,
} from '@src/actions/BotActions';
import { KEY_CODES } from '@src/constants/MogamboConstants';

import BotSaysHeaderDefault from './BotSaysHeaders/BotSaysHeaderDefault';
import BotSaysHeaderEntity from './BotSaysHeaders/BotSaysHeaderEntity';
import BotSaysHeaderDelay from './BotSaysHeaders/BotSaysHeaderDelay';
import BotSaysBody from './BotSaysBody';
import MandatoryWordsModal from './ManadatoryWordsModal';

export default class BotSaysCard extends React.Component {
  state = {
    // To make card open by default
    toggled: this.props.openCard || false,
  };

  _quickReplyDOMElements = [];

  // toggled state will be updated when the openCard prop gets changed
  componentWillReceiveProps(nextProps) {
    if (this.props.openCard != nextProps.openCard) {
      this.setState({
        toggled: nextProps.openCard,
      });
    }
  }

  render() {
    let activeClass = '';

    if (this.state.toggled) {
      activeClass = 'bot-says-toggled';
    }

    return (
      <Accordion.Item
        renderHeader={this._renderBotSaysHeader}
        active={this.state.toggled}
        onChange={this._toggle}
        className={activeClass}
      >
        <div className="bot-says-card-wrapper">
          {/* If we're getting any header for the bot says - Which is there in FAQ Nodes */}
          {this.props.faq_ww_header && this.props.faq_ww_header}
          <div className="bot-says-card">{this._renderBotSaysBody()}</div>
        </div>
      </Accordion.Item>
    );
  }

  _renderBotSaysHeader = () => {
    const additionalProps = {
      onToggle: this._toggle,
      DOMRef: this._setHeaderRef,
      onDelayChange: this._changeDelay,
      onHoldWithBotToggle: this._toggleHoldWithBot,
      onDelete: this.props.onDelete,
      onEdit: this.props.onEdit,
      onMandatoryWords: this._showMandatoryWordsModal,
      ...this.state,
    };

    switch (this.props.type) {
      case 'DEFAULT':
        return <BotSaysHeaderDefault {...this.props} {...additionalProps} />;
      case 'ENTITY':
        return <BotSaysHeaderEntity {...this.props} {...additionalProps} />;
      case 'DELAY':
        return <BotSaysHeaderDelay {...this.props} {...additionalProps} />;
      default:
        return null;
    }
  };

  _renderBotSaysBody = () => {
    const additionalProps = {
      onVariantsChange: this._onVariantsChange,
      onAddQuickReply: this._addQuickReply,
      onEditQuickReply: this._editQuickReply,
      onKeyUpQuickReply: this._keyUpQuickReply,
      onQuickRepliesRef: this._setQuickReplyRef,
      onSupportedPlatformsChange: this._onSupportedPlatformsChange,
      DOMRef: this._setBodyRef,
      blurred: this.props.blurred || !this.state.toggled,
      allPlatforms: this.props.disablePlatforms ? [] : this.props.allPlatforms,
      ...this.state,
    };

    return <BotSaysBody {...this.props} {...additionalProps} />;
  };

  _showMandatoryWordsModal = (e) => {
    e.stopPropagation();
    const title = 'Filter Values';
    const subtitle =
      'Add filter values to shortlist this step on the basis of this entity';
    const ModalComponent = (
      <MandatoryWordsModal
        words={this.props.value.mandatoryWords}
        onChange={this._updateMandatoryWords}
      />
    );
    openComponentModal(
      ModalComponent,
      title,
      subtitle,
      'CROSS',
      false,
      closeComponentModal
    );
  };

  _setQuickReplyRef = (i, DOMElement) => {
    this._quickReplyDOMElements[i] = DOMElement;
  };

  _setHeaderRef = (DOMElement) => {
    if (!this._header) {
      this._header = DOMElement;
    }
  };

  _setBodyRef = (DOMElement) => {
    if (!this._body) {
      this._body = DOMElement;
    }
  };

  _toggle = () => {
    this.setState({ toggled: !this.state.toggled });
  };

  _toggleHoldWithBot = (e) => {
    e.stopPropagation();
    this.props.onChange(
      'mandatory',
      !this.props.value.mandatory,
      null,
      null,
      true
    );
  };

  _changeDelay = (delay) => {
    this.props.onChange('time', delay);
  };

  _onVariantsChange = (val) => {
    this.props.onChange('variants', val);
  };

  _onSupportedPlatformsChange = (val) => {
    const newVal = {};
    const { variants } = this.props.value;
    Object.keys(val).forEach((key) => {
      const filteredVariants = val[key].filter((i) => i < variants.length);
      if (filteredVariants.length) newVal[key] = filteredVariants;
    });

    this.props.onChange('devicePlatformMap', newVal);
  };

  _addQuickReply = (dontMarkAsUpdate) => {
    const quickReplies = this.props.value.quickReplies.filter(
      (quickReply) => !!quickReply
    );
    quickReplies.push('');
    this.props.onChange(
      'quickReplies',
      quickReplies,
      () => {
        setTimeout(() => {
          this._quickReplyDOMElements[quickReplies.length - 1].focus();
        }, 0);
      },
      dontMarkAsUpdate
    );
  };

  _deleteQuickReply = (quickReplyIndex, cb) => {
    const quickReplies = this.props.value.quickReplies.filter(
      (_, index) => index !== quickReplyIndex
    );
    this.props.onChange('quickReplies', quickReplies, () => {
      cb && cb();
    });
  };

  _editQuickReply = (quickReplyIndex, newQuickReplyValue) => {
    const { quickReplies } = this.props.value;

    if (newQuickReplyValue.length > 0) {
      quickReplies[quickReplyIndex] = newQuickReplyValue;
      this.props.onChange('quickReplies', quickReplies, () => {});
    } else {
      this._deleteQuickReply(quickReplyIndex, () => {
        quickReplyIndex > 0
          ? this._quickReplyDOMElements[quickReplyIndex - 1].focus()
          : null;
      });
    }
  };

  _keyUpQuickReply = (e) => {
    if (e.keyCode == KEY_CODES.ENTER_KEY) {
      this._addQuickReply(true);
    }
  };

  _updateMandatoryWords = (words) => {
    this.props.onChange('mandatoryWords', words);
  };
}

const SortableBotSaysCard = SortableElement(BotSaysCard);
export { SortableBotSaysCard };
